
import { FC } from 'react';
import { Tag } from '@brg/api';
import { BTagWithChildren } from 'core/components/bTag/bTagWithChildren';
import { bTag } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { MobileTagIconBox } from './styles';

export enum TAGS_LEVEL {
    child = 0,
    children = 1,
    parent = 2,
}

interface IProps {
    item: Tag,
    selected?: Function;
    disabled?: boolean;
    parent?: boolean;
    isTagOpen?: boolean;
    removable?: Function;
    secondary?: boolean;
    educational?: boolean;
    onClick?: (tag: Tag, selected: boolean) => void;
    onParentClick?: (tag: Tag, selected: boolean) => void;
    onMoreClick?: (ev: any) => void;
    onTagArrowClick?: (ev: any, id?: string) => void;
    onSearchInputChange?: (ev: any) => void;
    onSearchIntoCategory?: (ev: any) => void;
    onFocus?: (ev: any) => void;
    variant?: string;
    children_item?: any[];
    isSearching?: boolean;
    searchNeeded?: boolean;
    moreNeeded?: boolean;
    opacity?: boolean;
    isEmptySearch?: boolean;
    test?: (ev: any) => void;
    onSetOpenTag?: (value: boolean) => void;
    tagsFilter?: ITagsProps;
    canOpenTag?: boolean;
    search?: string;
    mobileArrowVisible?: boolean;
    isLinkMode?: boolean;
}

const FoundChildrens: FC<IProps> = ({ 
    item,
    children_item,
    selected,
    onClick,
    onParentClick,
    onMoreClick,
    search,
    onTagArrowClick,
    onSearchInputChange,
    searchNeeded,
    moreNeeded,
    isSearching,
    isEmptySearch,
    mobileArrowVisible,
    canOpenTag,
    opacity, 
    tagsFilter,
    isLinkMode,
}) => {

    return (
        <BTagWithChildren 
            selected={selected}
            parent={true}
            search={search}
            children_item={children_item}
            isTagOpen={Boolean(canOpenTag)}
            parentTag={item}
            onClick={onClick}
            onParentClick={onParentClick}
            onMoreClick={onMoreClick}
            onTagArrowClick={(e) => {
                onTagArrowClick && onTagArrowClick(e, item?.tagId);
            }}
            onSearchInputChange={(e) => {
                onSearchInputChange && onSearchInputChange(e);
            }}
            opacity={opacity}
            searchNeeded={searchNeeded}
            moreNeeded={moreNeeded}
            isSearching={isSearching}
            entityTypes={item?.entityTypes}
            parentTagId={item?.tagId}
            isEmptySearch={isEmptySearch}
            tagsFilter={tagsFilter}
            mobileArrowVisible={mobileArrowVisible}
            hasLink={isLinkMode}
        >
            {mobileArrowVisible ? (
                <MobileTagIconBox> 
                    {bTag.title(item)}
                </MobileTagIconBox>
            ) : (
                bTag.title(item)
            )}
        </BTagWithChildren>
    )
}

export default FoundChildrens;

import { FC } from 'react';
import { Tag } from '@brg/api';
import { BTagWithChildren } from 'core/components/bTag/bTagWithChildren';
import { bTag } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { MobileTagIconBox } from './styles';

export enum TAGS_LEVEL {
    child = 0,
    children = 1,
    parent = 2,
}

interface IProps {
    item: Tag,
    selected?: Function;
    disabled?: boolean;
    parent?: boolean;
    isTagOpen?: boolean;
    removable?: Function;
    secondary?: boolean;
    educational?: boolean;
    onClick?: (tag: Tag, selected: boolean) => void;
    onParentClick?: (tag: Tag, selected: boolean) => void;
    onMoreClick?: (ev: any) => void;
    onTagArrowClick?: (ev: any, id?: string) => void;
    onSearchInputChange?: (ev: any) => void;
    onSearchIntoCategory?: (ev: any) => void;
    onFocus?: (ev: any) => void;
    variant?: string;
    children_item?: any[];
    isSearching?: boolean;
    searchNeeded?: boolean;
    moreNeeded?: boolean;
    opacity?: boolean;
    isEmptySearch?: boolean;
    test?: (ev: any) => void;
    onSetOpenTag?: (value: boolean) => void;
    tagsFilter?: ITagsProps;
    canOpenTag?: boolean;
    search?: string;
    mobileArrowVisible?: boolean;
    isLinkMode?: boolean;
}

const FoundChildrens: FC<IProps> = ({ 
    item,
    children_item,
    selected,
    onClick,
    onParentClick,
    onMoreClick,
    search,
    onTagArrowClick,
    onSearchInputChange,
    searchNeeded,
    moreNeeded,
    isSearching,
    isEmptySearch,
    mobileArrowVisible,
    canOpenTag,
    opacity, 
    tagsFilter,
    isLinkMode,
}) => {

    return (
        <BTagWithChildren 
            selected={selected}
            parent={true}
            search={search}
            children_item={children_item}
            isTagOpen={Boolean(canOpenTag)}
            parentTag={item}
            onClick={onClick}
            onParentClick={onParentClick}
            onMoreClick={onMoreClick}
            onTagArrowClick={(e) => {
                onTagArrowClick && onTagArrowClick(e, item?.tagId);
            }}
            onSearchInputChange={(e) => {
                onSearchInputChange && onSearchInputChange(e);
            }}
            opacity={opacity}
            searchNeeded={searchNeeded}
            moreNeeded={moreNeeded}
            isSearching={isSearching}
            entityTypes={item?.entityTypes}
            parentTagId={item?.tagId}
            isEmptySearch={isEmptySearch}
            tagsFilter={tagsFilter}
            mobileArrowVisible={mobileArrowVisible}
            hasLink={isLinkMode}
        >
            {mobileArrowVisible ? (
                <MobileTagIconBox> 
                    {bTag.title(item)}
                </MobileTagIconBox>
            ) : (
                bTag.title(item)
            )}
        </BTagWithChildren>
    )
}

export default FoundChildrens;
